import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as n } from "react";
const r = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M917.333 573.108v267.426H752.726V591.019c0-62.68-23.809-105.457-83.391-105.457-45.484 0-72.551 28.828-84.459 56.715-4.342 9.969-5.46 23.845-5.46 37.801v260.457H414.753s2.218-422.597 0-466.381H579.4v66.108c-.334.494-.768 1.028-1.082 1.507h1.082v-1.507c21.875-31.733 60.941-77.064 148.384-77.064 108.335-.002 189.55 66.658 189.55 209.912zM242.509 149.333c-56.331 0-93.176 34.8-93.176 80.564 0 44.766 35.779 80.623 90.99 80.623h1.1c57.422 0 93.133-35.85 93.133-80.623-1.082-45.764-35.711-80.564-92.047-80.564m-83.396 691.2h164.6V374.152h-164.6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = n(r);
export {
  m as default
};
